export function headerSticky() {
  // header sticky
  let lastScrollY = window.scrollY;
  const header = document.querySelector('header');
  const topOverlay = document.querySelector('.top-overlay');
  const navbar = document.querySelector('.navbar');
  const menuItems = header?.querySelectorAll(".menu-item.menu-item-has-children");

  const fireSticky = function () {
    const currentScrollY = window.scrollY;
    const isScrollingDown = currentScrollY > lastScrollY;
    const isPastThreshold = currentScrollY > 50;

    header.classList.toggle('hide', isScrollingDown && isPastThreshold);
    header.classList.toggle('sticky', isPastThreshold);
    menuItems.forEach(item => item.classList.remove("active-menu"));
    header.classList.remove('header-active');
    navbar.classList.remove('navbar-active');
    topOverlay.classList.toggle('show-overlay', isPastThreshold);
    lastScrollY = currentScrollY;

  };
  window.addEventListener('scroll', fireSticky);
  if (document.readyState === 'complete') {
    fireSticky();
  }
}
